export default __webpack_public_path__ + "static/media/giftr-login.3e5c3f77.svg";